<template>
  <Modal v-model="visible" class="my-modal top" width="1100px" :title="'审批详情（ID:' + changeData.id + '）'"
    :footer-hide="true" :mask-closable="false" @on-cancel="detailData = {}">
    <div class="base">
      <div class="item">
        <span class="label">发起时间</span>
        <span>{{ changeData.createTime }}</span>
      </div>
      <div class="item">
        <span class="label">发起人</span>
        <span>{{ changeData.salesmanName }}</span>
      </div>
      <div class="item">
        <span class="label">发起人所属机构</span>
        <span>{{ changeData.organName }}</span>
      </div>
      <div class="item">
        <span class="label">审批类型</span>
        <span>微店编辑审批</span>
      </div>
      <div class="item">
        <span class="label">审批项名称</span>
        <span>{{ changeData.name }}</span>
      </div>
      <div class="item">
        <span class="label">审批状态</span>
        <lzDicTxt dicType="CHECK_STATUS" :dicCode="changeData.status"></lzDicTxt>
      </div>
    </div>
    <div class="content" v-if="changeData.itemType == 1">
      <div class="title">
        变动内容
      </div>
      <div v-for="(item, index) in detailData.list" :key="index">
        <div class="contentItem">
          <loading :isShow="uploadLoading" />
          <span class="label">图片</span>
          <img :src="item.old.bannerImg" alt="" :preview="_uid" class="img" v-if="item.old">
          <div class="youjian" v-if="item.old"><img src="@/static/images/youjiantou.png" alt=""></div>
          <img :src="item.new.bannerImg" alt="" :preview="_uid" class="img" v-if="item.new">
        </div>
        <div class="contentItem">
          <span class="label">链接地址</span>
          <a :href="item.new.link" target="_blank" v-if="item.old && item.old.link" class="lianjie">{{ item.old.link
          }}</a>
          <span v-else-if="item.old">-</span>
          <div class="youjian" v-if="item.old"><img src="@/static/images/youjiantou.png" alt=""></div>
          <a :href="item.new.link" target="_blank" v-if="item.new && item.new.link" class="lianjie">{{ item.new.link
          }}</a>
          <span v-else-if="item.new">-</span>
        </div>
      </div>
    </div>
    <div class="content" v-if="changeData.itemType == 2">
      <div class="title">
        变动内容
      </div>
      <div v-for="(item, index) in detailData.list" :key="index">
        <div class="contentItem">
          <span class="label" v-if="item.new && item.new.parentId">子分类</span>
          <span class="label" v-else>主分类</span>
          <span v-if="item.old && item.old.name">{{ item.old.name }}</span>
          <div class="youjian" v-if="item.old"><img src="@/static/images/youjiantou.png" alt=""></div>
          <span v-if="item.new && item.new.name">{{ item.new.name }}</span>
        </div>
      </div>
    </div>
    <div class="ivu-modal-footer">
      <Button type="primary" v-if="changeData.status == '0'" @click="pass(changeData.id)">通过</Button>
      <Button type="primary" ghost @click="goback(changeData.id)" v-if="changeData.status != '-1'&&detailData.isReject">退回</Button>
    </div>
  </Modal>
</template>

<script>
import lzDicTxt from "@/components/commons/lzDicTxt";
export default {
  components: { lzDicTxt },
  data() {
    return {
      visible: false,
      uploadLoading: false,
      detailData: {},
      changeData: {}
    }
  },
  methods: {
    async open(val) {
      this.visible = true
      this.changeData = val
      await this.getDetail(val.id)
    },
    getDetail(id) {
      this.uploadLoading = true
      this.$http({
        url: `/buz/check/compareCheckData`,
        type: "GET",
        data: {
          id: id
        }
      }).then((res) => {
        this.detailData = res.data;
        this.$previewRefresh();
        this.uploadLoading = false
      }).catch(() => {
        this.uploadLoading = false
      })
    },
    pass(id) {
      this.$http({
        url: `/buz/check/passVersion`,
        type: "GET",
        data: {
          id: id
        }
      }).then((res) => {
        this.$notice.success('审核通过');
        this.visible = false
        this.$emit('refresh')
      })
    },
    goback(id) {
      this.$notice.inquiry("是否确认退回本次变动内容？").then(() => {
        this.$http({
          url: `/buz/check/rejectVersion`,
          type: "GET",
          data: {
            id: id
          }
        }).then((res) => {
          this.$notice.success('退回成功');
          this.visible = false
          this.$emit('refresh')
        })
      }).catch((err) => {
        console.log(err);
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.base {
  display: flex;
  flex-wrap: wrap;
  padding: 0 20px;
  border-bottom: 1px solid #eeeeee;

  .item {
    padding: 20px;
    width: 50%;

    .label {
      margin-right: 20px;
      display: inline-block;
      width: 110px;
    }
  }
}

.lianjie {
  max-width: 40%;
  word-break: break-all;
}

.content {
  margin-top: 20px;

  .title {
    font-weight: bold;
    color: #3C464F;
    margin-bottom: 10px;
  }

  .contentItem {
    padding: 40px;
    display: flex;

    .label {
      margin-right: 20px;
      display: inline-block;
      width: 80px;
    }


    .img {
      max-width: 300px;
      max-height: 200px;
    }

    .youjian {
      width: 60px;
      display: flex;
      align-items: center;
      margin: 0 40px;
    }
  }
}
</style>